var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.505 3.94465L26.2366 8.65246C27.2559 9.20237 27.2559 10.7716 26.2366 11.3216L17.505 16.0294C16.7271 16.4451 15.815 16.4451 15.0371 16.0294L6.30553 11.3216C5.28618 10.7716 5.28618 9.20237 6.30553 8.65246L15.0371 3.94465C15.815 3.52887 16.7271 3.52887 17.505 3.94465Z",
    stroke: "#24B632",
    strokeWidth: 1.71576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01831 14.4929L13.1329 18.5569C14.1388 19.0665 14.7826 20.0993 14.7826 21.226V28.8979C14.7826 30.0112 13.6157 30.7221 12.6232 30.2258L4.50863 26.1618C3.50269 25.6521 2.85889 24.6193 2.85889 23.4927V15.8207C2.85889 14.7075 4.02578 13.9966 5.01831 14.4929Z",
    stroke: "#24B632",
    strokeWidth: 1.71576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5246 14.4929L19.41 18.5569C18.4041 19.0665 17.7603 20.0993 17.7603 21.226V28.8979C17.7603 30.0112 18.9271 30.7221 19.9197 30.2258L28.0343 26.1618C29.0402 25.6521 29.684 24.6193 29.684 23.4927V15.8207C29.684 14.7075 28.5171 13.9966 27.5246 14.4929Z",
    stroke: "#24B632",
    strokeWidth: 1.71576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTai);
export default __webpack_public_path__ + "static/media/TAI.8cdaaa7832cf0f2a9f48e23e2652c61d.svg";
export { ForwardRef as ReactComponent };